import PropTypes from "prop-types"
import React, { useState } from "react"
import { useFormik } from "formik"
import { adminValidationSchema } from "../partnerSignupValidation"

const AdminUserForm = ({ initialValues, onSubmit, loading, apiError }) => {
  const [showPassword, setShowPassword] = useState(false)
  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: adminValidationSchema,
    onSubmit,
  })

  const renderError = name =>
    formik.touched[name] && formik.errors[name]
      ? <div className="partner-field-error">{formik.errors[name]}</div>
      : null

  const propsFor = name => ({
    name,
    value: formik.values[name],
    onChange: formik.handleChange,
    onBlur: formik.handleBlur,
    className: formik.touched[name] && formik.errors[name] ? "is-invalid" : "",
  })

  return (
    <section className="partner-page partner-account-page">
      <div className="partner-account-intro">
      <div className="partner-icon-badge"><i className="bx bx-user-check" /></div>
      <h1>Créez votre accès administrateur</h1>
      <p className="partner-lead">Cet utilisateur pourra gérer le commerce, publier les paniers et suivre les réservations.</p>
      <div className="partner-account-feature"><i className="bx bx-check" /><span>Gestion complète du commerce</span></div>
      <div className="partner-account-feature"><i className="bx bx-check" /><span>Suivi des réservations en temps réel</span></div>
      <div className="partner-account-feature"><i className="bx bx-check" /><span>Accès sécurisé après validation email</span></div>
      </div>

      <div className="partner-account-form-panel">
      {apiError && (
        <div className="partner-alert partner-alert-danger">
          {apiError}
          <span> Votre commerce a bien été créé. Vous pouvez corriger les informations et réessayer.</span>
        </div>
      )}

      <form onSubmit={formik.handleSubmit} noValidate>
        <div className="partner-form-grid">
          <div className="partner-field partner-field-full">
            <label htmlFor="partner-admin-email">Email *</label>
            <input id="partner-admin-email" type="email" autoComplete="email" placeholder="vous@commerce.com" {...propsFor("email")} />
            {renderError("email")}
          </div>
          <div className="partner-field partner-field-full">
            <label htmlFor="partner-admin-name">Nom complet *</label>
            <input id="partner-admin-name" type="text" autoComplete="name" placeholder="Votre nom complet" {...propsFor("fullName")} />
            {renderError("fullName")}
          </div>
          <div className="partner-field partner-password-field">
            <label htmlFor="partner-admin-password">Mot de passe *</label>
            <div className="partner-input-with-action">
              <input id="partner-admin-password" type={showPassword ? "text" : "password"} autoComplete="new-password" {...propsFor("password")} />
              <button type="button" onClick={() => setShowPassword(value => !value)} aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}>
                <i className={`bx ${showPassword ? "bx-hide" : "bx-show"}`} />
              </button>
            </div>
            {renderError("password")}
          </div>
          <div className="partner-field partner-password-field">
            <label htmlFor="partner-admin-password-confirmation">Confirmation *</label>
            <input id="partner-admin-password-confirmation" type={showPassword ? "text" : "password"} autoComplete="new-password" {...propsFor("passwordConfirmation")} />
            {renderError("passwordConfirmation")}
          </div>
        </div>
        <div className="partner-actions partner-actions-end">
          <button type="submit" className="partner-button partner-button-primary" disabled={loading}>
            {loading ? <><span className="partner-spinner" /> Création en cours...</> : <>Créer mon accès <i className="bx bx-right-arrow-alt" /></>}
          </button>
        </div>
      </form>
      </div>
    </section>
  )
}

AdminUserForm.propTypes = {
  apiError: PropTypes.string,
  initialValues: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
}

export default AdminUserForm
